import React from "react";
import { Tooltip, IconButton, TableCell } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { firmaElectronicaIcons, tipoFirmaElectronicaIcons } from "../ListadoSolicitud.iconMaps";

// Columna "Digital": ícono/estado de firma electrónica, habilitado para abrir
// el modal de firma solo cuando `puedeFirmar` es true.
export default function CeldaDigital({ data, puedeFirmar, handleOpenFirmaElectronica, handlePopoverOpen }) {
  return (
    <TableCell align="center">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 4,
        }}
      >
        {tipoFirmaElectronicaIcons[data.TipoFirmaElectronica] && (
          <Tooltip
            title={
              data.Estado === 6 ? firmaElectronicaIcons[data.idFirmaElectronica]?.tooltip : tipoFirmaElectronicaIcons[data.TipoFirmaElectronica]?.tooltip
            }
            arrow
            placement="top"

          >
            <span>
              <IconButton
                size="small"
                disabled={!puedeFirmar}
                onClick={
                  puedeFirmar
                    ? () => handleOpenFirmaElectronica(data)
                    : undefined
                }
                sx={{
                  bgcolor: firmaElectronicaIcons[data.idFirmaElectronica].color,
                  color: firmaElectronicaIcons[data.idFirmaElectronica].color,
                  "&:hover": {
                    bgcolor: firmaElectronicaIcons[data.idFirmaElectronica].color || "#e2e8f0",
                    transform: firmaElectronicaIcons[data.idFirmaElectronica].color ? "scale(1.1)" : "none",
                  },
                  transition: "all 0.2s ease",
                }}
              >
                {firmaElectronicaIcons[data.idFirmaElectronica].icon}
              </IconButton>
            </span>
          </Tooltip>
        )}

        <MoreVertIcon
          onClick={(event) => handlePopoverOpen(event, 11, data)}
          style={{ cursor: "pointer" }}
        />
      </div>
    </TableCell>
  );
}
